// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__3ouY8","itemTitle":"ClientEmergencyInfo_itemTitle__1XMnZ","itemText":"ClientEmergencyInfo_itemText__2h_OC"};